import { PersonalizedNotificationTemplateEditScreen } from "./personalized-notification-template-edit.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const PersonalizedNotificationTemplateEditRoutes: RouteDefinition[] = [
	{
		path: Paths.personalizedNotificationTemplates.withIdPlaceholder().edit.path,
		element: <PersonalizedNotificationTemplateEditScreen />,
		requiredPermissions: ["AccountPermission_System_Root"],
	},
];
